import { Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import './style.css'

const Range = ({data, inputs, handleChange, disabled}) => {

  return (
    <Form.Group className={data.class} controlId={data.nameForm}>
			<Form.Label>{data.name}</Form.Label>
			<OverlayTrigger
				placement="top"
				overlay={<Tooltip id="range-tooltip">
					{inputs[data.nameForm]}
				</Tooltip>}
			>
				<Form.Range
					id={`${data.nameForm}-${data.type}`}
					label={data.name}
					required={data.required}
					placeholder={data.placeholder}
					name={data.nameForm}
					min={data.min || 0}
					max={data.max || 100}
					step={data.step || 1}
					value={inputs[data.nameForm] || ''}
					disabled={disabled}
					onChange={handleChange}
				/>
			</OverlayTrigger>
		</Form.Group>
  )
}

export default Range
